import { render, staticRenderFns } from "./CardknoxIfield.vue?vue&type=template&id=764a5d82"
import script from "./CardknoxIfield.vue?vue&type=script&setup=true&lang=js"
export * from "./CardknoxIfield.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports